import React from 'react';
import { bool, func, string } from 'prop-types';

import SearchIcon from '@assets/Icon/searchBar/SearchIcon';

import { Container, Row, Col, Typography, Button } from '@ajaibid/components';
import { decimalFormat } from '@ajaibid/utils';
import { PriceChangeTicker } from 'Component/Ticker';
import SpecialNotation from 'Component/SpecialNotation';
import useRealtimeStockPrice from '@context/websocket/useRealtimeStockPrice';
import stockService from '@services/stock';

import { styHeaderGrid } from './style';

const StockBuySellHeader = (props) => {
  const { code, withSearch, onClickSearch } = props;

  const { data: stockAbout } = stockService.detail.about.useAbout(code);
  const { data: stockPrice } = useRealtimeStockPrice(code);

  return (
    <Container padding="16px 16px 12px">
      <Row gutters={8}>
        <Col size="auto">
          <img
            height={32}
            width={32}
            src={stockAbout?.icon_url}
            alt=""
            data-testid="img-stockLogo"
          />
        </Col>
        <Col>
          <div className={styHeaderGrid}>
            <span>
              <Typography
                type="body"
                size="md"
                bold
                overflow="nowrap"
                margin={0}
                data-testid="txt-stockCode"
              >
                {stockAbout?.code}
              </Typography>
              <SpecialNotation specialNotation={stockAbout?.special_notations} />
            </span>
            <Typography type="body" size="sm" margin={0} data-testid="txt-stockName">
              {stockAbout?.name}
            </Typography>
            <span>
              <Typography
                type="subheading"
                bold
                overflow="nowrap"
                margin={0}
                data-testid="txt-price"
              >
                {decimalFormat(stockPrice?.price)}
              </Typography>
              <PriceChangeTicker
                change={stockPrice?.return_amount}
                percentage={stockPrice?.return_pct}
              />
            </span>
          </div>
        </Col>
        {withSearch && (
          <Col size="auto">
            <Button.Icon
              variant="naked-black"
              size="md"
              icon={<SearchIcon />}
              onClick={onClickSearch}
              data-testid="btn-search"
            />
          </Col>
        )}
      </Row>
    </Container>
  );
};

StockBuySellHeader.propTypes = {
  code: string,
  withSearch: bool,
  onClickSearch: func,
};

StockBuySellHeader.defaultProps = {
  code: '',
  withSearch: false,
  onClickSearch: () => {},
};

export default StockBuySellHeader;
